// extracted by mini-css-extract-plugin
export default {"form":"K13v8uYumcyIsz0QUSRa","auth_inputs":"Tr_D8hp8939h9MU884Rl","auth_label":"zKI5lipEqBPaJAO0kos2"};